import { once } from "lodash";
import React, { createContext, useContext } from "react";
import { getGridRowClasses, getGridRowStyles } from "../../GridStyles";
import { getRowMetadata } from "../../functions/getRowMetadata";
import DataGridRow from "./DataGridRow";
export function DataRowRenderer({ index: rowIndex, style: styles, data }) {
    const { page, rows, focusedRowId, onRowIdFocus, allowPagination } = data;
    const rowContext = useContext(createDataGridRowContext());
    if (!rowContext) {
        throw new Error("Row context is missing.");
    }
    const { allowSelection, columns, fixedColumnCount, getColumnWidth, getRowProps, getIsRowLoading, getIsRowReadOnly, prepareRow } = rowContext;
    const row = allowPagination ? page[rowIndex] : rows[rowIndex];
    if (!row) {
        return null;
    }
    const { isRowLoading, isRowReadOnly } = getRowMetadata({ row, getIsRowLoading, getIsRowReadOnly });
    const gridRowStyles = getGridRowStyles({
        isRowReadOnly,
        row,
        focusedRowId,
        rowPropsClassName: getRowProps ? getRowProps(row).className : undefined
    });
    const rowClasses = getGridRowClasses({
        isRowReadOnly,
        defaultRowClasses: ["data-grid-row"],
        row,
        focusedRowId,
        rowPropsClassName: getRowProps ? getRowProps(row).className : undefined
    });
    const customGetRowProps = (row) => {
        const style = {
            ...styles,
            ...(getRowProps && getRowProps(row).style),
            width: "inherit"
        };
        return {
            onKeyDown: (e) => {
                if (getRowProps && getRowProps(row).onClick) {
                    if (!isRowReadOnly && (e.key === "Enter" || e.key === " ")) {
                        e.currentTarget.click();
                    }
                }
            },
            ...(getRowProps && getRowProps(row)),
            className: rowClasses.join(" "),
            style: style,
            //The only way to focus on a row would be to use ArrowUp/ArrowDown or click a row - both of which will call onItemFocus
            //Therefore, no need to call onItemFocus here again
            onFocus: (e) => {
                //stopPropagation to prevent calling rowsContainer onFocus
                e.stopPropagation();
                onRowIdFocus(row);
                const onFocusProp = getRowProps ? getRowProps(row).onFocus : undefined;
                if (onFocusProp) {
                    onFocusProp(e);
                }
            }
        };
    };
    prepareRow(row);
    return (React.createElement(DataGridRow, { allowSelection: allowSelection, columns: columns, focusedRowId: focusedRowId, fixedColumnCount: fixedColumnCount, getColumnWidth: getColumnWidth, getRowProps: customGetRowProps, isRowLoading: isRowLoading, isRowReadOnly: isRowReadOnly, row: row, key: `data-grid-row ${rowIndex}`, rowIndex: rowIndex, sx: gridRowStyles }));
}
export const createDataGridRowContext = once(() => {
    return createContext(null);
});
